import React, { Component } from 'react';
import HeaderImage from '../src/images/header.png';
import { Link } from 'react-router-dom';
import { Grid, Divider, Dropdown, Button, Modal, Menu, Header, Image, Message, Icon } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import './index.css';
import config from './config.json';
import $ from 'jquery';
import AgencyInfo from './AgencyInfo';
import sha256 from 'sha256';
import { withRouter } from 'react-router';
import { Footer } from './layout/footer';

const Authentication =
{
    token: "",
    isValid: false
};

let agencies = new AgencyInfo()

let timeout = null;
//let loginName = '';

function setToken(userToken, log) {
    //Set the token in the session so it can be checked later
    sessionStorage.setItem('token', JSON.stringify({ id: userToken, logged: log }));
}


class Login extends Component {

    constructor(props) {
        super(props);
        this.finishedExit = false;
        let url = window.location.origin + window.location.pathname.replace(/\/$/, "");
        sessionStorage.setItem('url', url);
    }

    state = {
        visible: false,
        mode: "Gmaps",
        agencies: [],
        selectedAgency: 0,
        selectedState: 1,
        activeItem: 'ViewOnly',
        username: "",
        password: "",
        loginError: null,
        shouldEnableButton: false,
        shouldHideFooter: false,
        showPassword: false,
        newPassword: "",
        confirmPassword: "",
        needsNewPassword: false,
        showNewPassword: false,
        showConfirmPassword: false,
        matchPassword: false,
        agencyId: 0,
        success: false,
        secondaryUserId: 0
    };

    optionsState = [
        { key: '1a', text: 'All', value: 1 },
        { key: '2nd', text: 'ND', value: 2 },
        { key: '3mn', text: 'MN', value: 3 },
        { key: '4sd', text: 'SD', value: 4 },
    ]
    handleOnFocusToHideFooter = () => {
        if (window.mobileAndTabletcheck()) {
            this.setState({ shouldHideFooter: true });
        }
    }
    handleOnFocusToBringFooter = () => {
        if (window.mobileAndTabletcheck()) {
            this.setState({ shouldHideFooter: false });
        }
    }
    handleItemClick = (e, { name }) => this.setState({ activeItem: name })

    handleDismiss = () => {
        this.setState({
            loginError: null,
            success: false
        });
    }

    render() {

        const agencyOptions = [];
        // have to do it this way AFAIK or things won't load properly
        this.state.agencies.map((item) => {
            if (item && !item.isSuperAdmin) {
                const data = {
                    key: item.key + item.label, value: item.value, text: item.label
                }
                // state sorting
                if (item.state === this.optionsState[this.state.selectedState - 1].text) {
                    agencyOptions.push(data);
                }
                // choose all
                else if (this.state.selectedState === 1) {
                    agencyOptions.push(data);
                }
            }
        });
        console.log(agencyOptions)
        agencyOptions.sort((a, b) => a.text.localeCompare(b.text))

        const displayTabs = {
            "ViewOnly":
                <div>
                    <div className="pt-form-group pt-small" style={{ margin: 'auto', width: 300 }}>
                        <Button.Group basic>
                            <div style={{ width: 100 }}>
                                <Dropdown button fluid search options={this.optionsState} placeholder="All"
                                    name="stateDropdown" value={this.state.selectedState}
                                    onFocus={this.handleOnFocusToHideFooter}
                                    onBlur={this.handleOnFocusToBringFooter}
                                    onChange={(e, { value }) => {
                                        this.setState({
                                            selectedState: parseInt(value),
                                            selectedAgency: 0,
                                            shouldEnableButton: false
                                        });

                                    }} />
                            </div>
                            <div style={{ width: 200 }}>
                                <Dropdown button fluid search options={agencyOptions} placeholder={"Counties"}
                                    name="agencyDropdown" value={this.state.selectedAgency}
                                    onFocus={this.handleOnFocusToHideFooter}
                                    onBlur={this.handleOnFocusToBringFooter}
                                    onChange={(e, { value }) => {
                                        this.setState({
                                            selectedAgency: parseInt(value),
                                            shouldEnableButton: true
                                        })

                                    }} />
                            </div>
                        </Button.Group>
                    </div>
                    <div className="pt-form-group pt-small" style={{ margin: 'auto', marginTop: 5, width: 200 }}>
                        <Button secondary
                            onClick={() => {
                                agencies.setAgencies(this.state.selectedAgency);
                                //set to a public login
                                setToken(this.state.selectedAgency, false)
                                let url = sessionStorage.getItem('url') + '/publicmap';
                                window.location.href = url;
                            }}
                            style={{ width: 200, margin: 'auto' }} disabled={!this.state.shouldEnableButton} >View Only
                        </Button>

                    </div>

                </div>
            ,
            // TEMPORARY BUTTON FOR ACCESSING Virtual Image Capture 
            "VRIC":
                <div className="pt-form-group pt-small" style={{ margin: 'auto', marginTop: 5, width: 200 }}>
                    <Button primary
                        onClick={() => {
                            agencies.setAgencies(this.state.selectedAgency);
                            this.props.history.push('/maing-dynamic');
                        }}
                        style={{ width: 200, margin: 'auto' }}>Virtual Image Capture</Button>
                </div>,
            "Editor":

                <div>
                    {/* <form> */}
                    <form onSubmit={this.onLogin}>

                        {!this.state.needsNewPassword &&
                            <div>
                                <div className="pt-form-group pt-input-group pt-small" style={{ margin: 'auto', width: 200 }}>
                                    <span className="pt-icon pt-icon-person"></span>
                                    <input type="text" className="pt-input" value={this.state.username}

                                        onChange={({ target }) => {
                                            this.setState({ username: target.value });
                                        }}
                                        onFocus={this.handleOnFocusToHideFooter}
                                        onBlur={this.handleOnFocusToBringFooter}
                                        placeholder="Username" />
                                </div>
                                <Divider hidden />

                                <div className="pt-form-group pt-input-group pt-small" style={{ margin: 'auto', width: 200 }}>
                                    <span className="pt-icon pt-icon-lock"></span>
                                    <input type={`${this.state.showPassword ? 'text' : 'password'}`} className="pt-input"
                                        value={this.state.password}
                                        onChange={({ target }) => {
                                            this.setState({ password: target.value });
                                        }}
                                        onFocus={this.handleOnFocusToHideFooter}
                                        onBlur={this.handleOnFocusToBringFooter}
                                        placeholder="Password" />
                                    <span onClick={() => { this.setState({ showPassword: !this.state.showPassword }); }} className={`password-eye pt-icon ${this.state.showPassword ? 'pt-icon-eye-on' : 'pt-icon-eye-off'}`}></span>
                                </div>

                                <Divider hidden />

                                <div className="pt-form-group pt-small" style={{ margin: 'auto', marginTop: 5, width: 200 }}>
                                    <Button primary
                                        style={{ width: 180 }}>Login</Button>
                                </div>
                            </div>
                        }

                        {this.state.needsNewPassword &&
                            <div>       <div className="pt-form-group pt-input-group pt-small" style={{ margin: 'auto', width: 200 }}>
                                <span className="pt-icon pt-icon-lock"></span>
                                <input type={`${this.state.showNewPassword ? 'text' : 'password'}`} className="pt-input"
                                    value={this.state.newPassword}
                                    onChange={({ target }) => {
                                        this.setState({ newPassword: target.value });
                                        if (this.state.confirmPassword === target.value && target.value !== '')
                                            this.setState({ matchPassword: true });
                                        else this.setState({ matchPassword: false });
                                    }}
                                    onFocus={this.handleOnFocusToHideFooter}
                                    onBlur={this.handleOnFocusToBringFooter}
                                    placeholder="New Password" />
                                <span onClick={() => { this.setState({ showNewPassword: !this.state.showNewPassword }); }} className={`password-eye pt-icon ${this.state.showNewPassword ? 'pt-icon-eye-on' : 'pt-icon-eye-off'}`}></span>
                            </div>

                                <Divider hidden />

                                <div className="pt-form-group pt-input-group pt-small" style={{ margin: 'auto', width: 200 }}>
                                    <span className="pt-icon pt-icon-lock"></span>
                                    <input type={`${this.state.showConfirmPassword ? 'text' : 'password'}`} className="pt-input"
                                        value={this.state.confirmPassword}
                                        onChange={({ target }) => {
                                            this.setState({ confirmPassword: target.value });
                                            if (this.state.newPassword === target.value && target.value !== '')
                                                this.setState({ matchPassword: true });
                                            else this.setState({ matchPassword: false });
                                        }}
                                        onFocus={this.handleOnFocusToHideFooter}
                                        onBlur={this.handleOnFocusToBringFooter}
                                        placeholder="Confirm Password" />
                                    <span onClick={() => { this.setState({ showConfirmPassword: !this.state.showConfirmPassword }); }} className={`password-eye pt-icon ${this.state.showConfirmPassword ? 'pt-icon-eye-on' : 'pt-icon-eye-off'}`}></span>
                                </div>

                                <Divider hidden />

                                <div className="pt-form-group pt-small" style={{ margin: 'auto', marginTop: 5, width: 200 }}>
                                    <Button primary disabled={!this.state.confirmPassword || !this.state.newPassword || !this.state.agencyId}
                                        style={{ width: 180 }}>Submit</Button>
                                    <a onClick={() => { this.setState({ needsNewPassword: false, success: false, loginError: null }); }} style={{ textDecoration: 'underline', textAlign: 'center', paddingTop: 10 }}>Go Back</a>
                                </div>
                            </div>
                        }

                        <Divider hidden />

                        {this.state.loginError &&
                            <Message negative style={{ margin: 'auto', width: 400 }} onDismiss={this.handleDismiss}>
                                <Message.Header>{this.state.needsNewPassword ? 'Failed!' : 'Authentication failed!'}</Message.Header>
                                <p>{this.state.loginError}</p>
                            </Message>
                        }

                        {this.state.success &&
                            <Message positive style={{ margin: 'auto', width: 400 }} onDismiss={this.handleDismiss}>
                                <Message.Header>Success</Message.Header>
                                <p>New Password set successfully. Click go back and try login.</p>
                            </Message>
                        }

                        <Divider hidden />
                    </form>
                    {!this.state.needsNewPassword &&
                        <div className="pt-form-group pt-small" style={{ margin: 'auto', marginTop: -15, width: 240, textAlign: 'center' }}>
                            <Grid divided='vertically'>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <Link to='/resetpassword' style={{ textDecoration: 'underline' }}>Reset Password</Link>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Link to='/forgetpassword' style={{ textDecoration: 'underline' }}>Forgot Password</Link>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row columns={1}>
                                    <Grid.Column>
                                        <Link to='/adduser' style={{ textDecoration: 'underline' }}>Add User</Link>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </div>
                    }
                </div>,
            "Help":
                <div style={{ margin: 'auto', marginTop: 5, width: 400 }}>
                    <p>Help is provided in the application through the help icons</p>
                    <p>GRIT Help Videos</p>
                    <ul>
                        <li><a target='new' href='http://dotsc.ugpti.ndsu.nodak.edu/grit_help/GRIT_Overview_and_Navigation.mp4' style={{ textDecoration: 'underline' }}>Overview and Navigation</a></li>
                        <li><a target='new' href='http://dotsc.ugpti.ndsu.nodak.edu/grit_help/GRIT_Editing_Location.mp4' style={{ textDecoration: 'underline' }}>Editing Locations</a></li>
                        <li><a target='new' href='http://dotsc.ugpti.ndsu.nodak.edu/grit_help/GRIT_Construction_Segment_Data_Items.mp4' style={{ textDecoration: 'underline' }}>Construction History Layer</a></li>
                        <li><a target='new' href='http://dotsc.ugpti.ndsu.nodak.edu/grit_help/GRIT_Load_Restrictions_Data_Items.mp4' style={{ textDecoration: 'underline' }}>Load Restrictions Layer</a></li>
                        <li><a target='new' href='http://dotsc.ugpti.ndsu.nodak.edu/grit_help/GRIT_Minor_Structures.mp4' style={{ textDecoration: 'underline' }}>Minor Structures Layer</a></li>
                        <li><a target='new' href='http://dotsc.ugpti.ndsu.nodak.edu/grit_help/GRIT_Construction_Planning.mp4' style={{ textDecoration: 'underline' }}>Construction Planning Layer</a></li>
                        <li><a target='new' href='http://dotsc.ugpti.ndsu.nodak.edu/grit_help/GRIT_Maintenance.mp4' style={{ textDecoration: 'underline' }}>Maintenance Layer</a></li>
                        <li><a target='new' href='http://dotsc.ugpti.ndsu.nodak.edu/grit_help/GRIT-performance-forecasting.mp4' style={{ textDecoration: 'underline' }}>Performance Forecasting</a></li>
                        <li><a target='new' href='http://dotsc.ugpti.ndsu.nodak.edu/grit_help/Township Assistance Program.mp4' style={{ textDecoration: 'underline' }}>NDDOT Township Assistance Program</a></li>
                    </ul>
                </div>,
            "Contact":
                <div style={{ margin: 'auto', marginTop: 5, width: 400 }}>
                    <p>Please contact agency responsible for asset-related questions.</p>
                    <p>Please contact for applications questions and feedback: <a href='mailto:grit@ugpti.org'>grit@ugpti.org</a></p>
                    <p>Please visit official UGPTI site for more details: <a target="_blank" href='https://www.ugpti.org/resources/grit/help.php'>https://www.ugpti.org/resources/grit/help.php</a></p>
                </div>
        };

        // no if or switch statements :)
        let segValue = displayTabs[this.state.activeItem];

        return (
            <div className="loginHolder"
            >
                <Grid stackable relaxed centered style={{ height: '100%', margin: 0 }} columns={1} >
                    <Grid.Column
                        width={12}
                        style={{
                            backgroundColor: 'white',
                            border: '1px none #CCCCCC',
                            borderLeftStyle: 'solid',
                            borderRightStyle: 'solid',
                            position: 'relative',
                            margin: '0',
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: '100vh'
                        }}
                    >


                        <Grid.Row >
                            {/* Header portion */}
                            <Image style={{ margin: 'auto' }} src={HeaderImage} />

                            <Divider hidden />

                            {/* AppName */}
                            <Grid.Row>
                                <Grid.Column>
                                    <h2 style={{ textAlign: 'center' }}>Geographic Roadway Inventory Tool</h2>
                                </Grid.Column>
                            </Grid.Row>
                            <Divider hidden />

                            {/* Navigation */}
                            <Grid.Column width={4}>
                                <Menu pointing secondary style={{ border: '0px' }}>
                                    <Menu.Item name='ViewOnly'
                                        active={this.state.activeItem === 'ViewOnly'}
                                        onClick={this.handleItemClick} />
                                    <Menu.Item name='Editor'
                                        active={this.state.activeItem === 'Editor'}
                                        onClick={this.handleItemClick} />
                                    <Menu.Item name='Help'
                                        active={this.state.activeItem === 'Help'}
                                        onClick={this.handleItemClick} />
                                    <Menu.Item name='Contact'
                                        active={this.state.activeItem === 'Contact'}
                                        onClick={this.handleItemClick} />
                                </Menu>
                            </Grid.Column>

                            <Divider hidden />
                            <Grid.Row>
                                <Divider />
                            </Grid.Row>

                            {/* Injected content goes here */}
                            <Grid.Row>
                                {segValue}
                            </Grid.Row>

                            <Grid.Row>

                                <div className="pt-form-group pt-small" style={{ margin: 'auto', marginTop: 175 }}>

                                    <strong style={{ color: 'red', fontSize: 16, margin: 'auto' }}>This application will run in any browser except Internet Explorer.</strong>
                                </div>
                            </Grid.Row>
                            {/* Footer */}
                            <Grid.Row >

                                {/*Insert footer component*/}
                                <Footer />
                            </Grid.Row>
                            <Divider hidden />

                            {/*</Segment>*/}
                        </Grid.Row>
                    </Grid.Column>
                </Grid>
            </div>
        );
    }

    switchMode = ({ target }) => {
        this.setState({ mode: target.value });
        console.log(target.value);
    }

    async componentDidMount() {
        await this.props.ag.init()

        if (!this.finishedExit) {
            this.setState({ visible: true });
        }
        //Wait for the constructor setup to complete

        this.setState({ agencies: agencies.getAgenciesDropdown() })

        //console.log(this.props);
        const { search } = this.props.location;

        if (search === "?activeItem=Help") {
            this.setState({ activeItem: "Help" });
        } else if (search === "?activeItem=Editor") {
            this.setState({ activeItem: "Editor" });
        }
    }


    onLogin = (e) => {
        this.setState({ visible: false });
        this.finishedExit = true;

        //AgencyInfo.setAgencies(this.state.selectedAgency);

        if (this.state.needsNewPassword) {
            this.confirmPassword(e);
            // if (this.state.matchPassword) {
            //     this.confirmPassword(e);
            // } else {

            // }
        } else {
            this.validateLogin(e);
        }
    }

    exitCallback = () => {
        if (this.finishedExit) {
            if (this.state.mode === "Gmaps") {
                this.props.history.push('/maing');
            }
            else if (this.state.mode === "Leaflet") {
                this.props.history.push('/mainl');
            }
            else if (this.state.mode === "Wrld") {
                this.props.history.push('/mainw');
            }
        }
    }

    exitCallbackRoute = (reroute = null) => {
        let params = '/' + (reroute ? reroute : 'maing');
        let url = sessionStorage.getItem('url') + params;
        window.location.href = url;
    }

    componentDidUpdate() {

    }

    validateLogin = (e) => {

        const passHash = sha256(this.state.password).toString('hex');

        $.ajax({
            type: 'POST',
            url: `${config.server}/login/authenticate`,
            data: {
                UserNameID: this.state.username,
                Password: passHash //hasha(this.state.password)

            }// + salt = 'grit1234'
        })
            .done((data) => {
                console.log(data);
                if (data.Message === "valid") {
                    Authentication.token = data.Token;
                    setToken(data.AgencyId, true)
                    sessionStorage.setItem('user', JSON.stringify({ 'agencyId': data.AgencyId, 'name': data.Name, 'email': data.Email, isSuperAdmin: data.IsSuperAdmin, secondaryUserId: data.SecondaryUserId }));
                    this.setState({ login: true });
                    agencies.setAgencies(data.AgencyId)
                    if (data.reroute) {
                        this.exitCallbackRoute(data.reroute);
                    }
                    else {
                        this.exitCallbackRoute();
                    }

                    // create timeout function
                    if (timeout !== null) {
                        clearInterval(timeout);
                    }
                } else if (data.Message === "needsnewpassword") {
                    this.setState({ success: false, needsNewPassword: true, loginError: null, showPassword: false, agencyId: data.AgencyId, secondaryUserId: data.SecondaryUserId });
                }
                else {
                    Authentication.isValid = false;
                    this.setState({ login: false });
                    this.setState({
                        success: false, loginError: data.Description || "Username or Password incorrect"
                    });
                }
            })
            .fail((jqXhr) => {
                console.log('failed to connect to server');
                console.log(jqXhr);
            });

        e.preventDefault();
    }

    confirmPassword = (e) => {
        $.ajax({
            type: 'POST',
            url: `${config.server}/confirmpassword/authenticate`,
            data: {
                AgencyId: this.state.matchPassword && this.state.secondaryUserId == 0 ? this.state.agencyId : 0,
                SecondaryUserId: this.state.secondaryUserId,
                NewPassword: this.state.newPassword
            }
        })
            .done((data) => {
                console.log(data);
                this.setState({
                    newPassword: "",
                    confirmPassword: ""
                });
                if (data.Message === "success") {
                    this.setState({ login: false });
                    this.setState({
                        loginError: null, success: true
                    });
                }
                else {
                    if (!this.state.matchPassword) {
                        alert('New and Confirm password not matched!');
                    } else {
                        Authentication.isValid = false;
                        this.setState({ login: false });
                        this.setState({
                            success: false, loginError: data.Description || "Failed to save"
                        });
                    }
                }
            })
            .fail((jqXhr) => {
                console.log('failed to connect to server');
                console.log(jqXhr);
            });

        e.preventDefault();
    }

    static ValidateServerToken(onLogout, onLogin = null) {

        console.log('validating this page....');

        // validate async
        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/login/validate`,
            data: { Token: Authentication.token }
        })
            .done((data) => {
                console.log(data);
                if (data.Message === "Valid") {
                    Authentication.isValid = true;
                    //Authentication.token = data.Token;
                    if (onLogin) {
                        onLogin();
                    }
                }
                // logout
                else if (data.Message === "InValid") {
                    Authentication.isValid = false
                    onLogout();
                }
            })
            .fail((jqXhr) => {
                console.log('failed to connect to server');
                onLogout();
            });
    }
}

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/login.js